<template>
  <div>
    <v-dialog
      v-model="show"
      persistent
      :width="options.width"
      v-bind:style="{ zIndex: options.zIndex }"
    >
      <v-card :color="options.color" dark>
        <v-card-text>
          {{ message }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "LoaderDialog",
  props: {
    stockDialog: { type: Boolean, required: true },
    showLoader: { type: Boolean, required: true },
  },
  data () {
    return {
      message: "Please wait...",
      options: {
        color: 'primary',
        width: 290,
        zIndex: 2
      },
    };
  },
  computed: {
    show () {
      let vm = this;
      return vm.stockDialog && vm.showLoader;
    },
  }
}
</script>

<style lang="scss" scoped>
</style>